export default __webpack_public_path__ + "static/media/Bas02.7cf981b2.jpg";